<style lang="scss">
    .infinity-loading-icon {
        display: block;
        transition: opacity 500ms;
        visibility: visible;
        opacity: 1;
        background-image: url(https://i.imgur.com/YB4fJJk.gif);
        width: 100px;
        height: 100px;
        background-size: 100px 100px;
        margin: 0 auto;
    }
</style>

<template>
    <div class="infinity-loading-icon"></div>
</template>

<script>
    export default {
        
    }
</script>
